export default function formatAcademyEntryType(name?: string): string | undefined {
	if (!name) return undefined;

	// Normalize whitespace and remove special characters
	const clean = name
		.trim()
		.toLowerCase()
		// Replace non-alphanumeric (except space & &) with space
		.replace(/[^a-z0-9\s&]/g, ' ')
		// Replace "&" with "and"
		.replace(/&/g, 'and')
		// Collapse multiple spaces
		.replace(/\s+/g, ' ');

	// Split words and camelCase them
	const parts = clean.split(' ');
	const camel = parts.map((word, i) => (i === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1))).join('');

	// Special case: Open House & Exhibition → "event"
	if (camel === 'openHouseAndExhibition') return 'event';

	return camel;
}
